import React from "react";
import { Activity, ShieldAlert, Users as UsersIcon, KeyRound, Terminal } from "lucide-react";
import { api } from "../../lib/api";
import PageHeader from "../../components/PageHeader";
import { StatCard, StatSkeleton, EmptyState, PanelCard, PanelSkeleton } from "./_shared";

/** AP-021 · TI dashboard variant. */
export default function DashboardIT() {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    let cancelled = false;
    api.get("/stats/it")
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="dashboard-it" className="space-y-6">
      <PageHeader
        testid="dashboard-it-header"
        title="Painel · TI"
        subtitle="Auditoria, saúde do sistema, ações mais executadas."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {loading ? (
          <>
            <StatSkeleton /><StatSkeleton /><StatSkeleton /><StatSkeleton />
          </>
        ) : (
          <>
            <StatCard testid="it-logs-24h"    label="Eventos (24h)"       value={data?.logs_24h ?? 0}    icon={Activity} accent />
            <StatCard testid="it-logs-7d"     label="Eventos (7d)"        value={data?.logs_7d ?? 0}     icon={Terminal} />
            <StatCard testid="it-failed"      label="Logins falhados (7d)" value={data?.failed_logins ?? 0} icon={ShieldAlert} />
            <StatCard testid="it-users"       label="Usuários / Funcion."  value={`${data?.users ?? 0} / ${data?.employees ?? 0}`} icon={UsersIcon} />
          </>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PanelCard title="Ações mais comuns (7 dias)" testid="it-top-actions" icon={KeyRound}>
          {loading ? <PanelSkeleton /> : (
            (data?.top_actions || []).length === 0
              ? <EmptyState label="Sem eventos registrados no período." />
              : (
                <ul className="divide-y divide-border">
                  {data.top_actions.map((r) => (
                    <li key={r.action} className="flex items-center justify-between py-2 text-sm">
                      <span className="font-mono text-xs">{r.action}</span>
                      <span className="text-muted-foreground">{r.count}</span>
                    </li>
                  ))}
                </ul>
              )
          )}
        </PanelCard>
        <PanelCard title="Estrutura RBAC" testid="it-rbac" icon={UsersIcon}>
          {loading ? <PanelSkeleton /> : (
            <div className="text-sm space-y-2">
              <p className="flex justify-between"><span className="text-muted-foreground">Papéis cadastrados</span> <strong>{data?.roles ?? 0}</strong></p>
              <p className="flex justify-between"><span className="text-muted-foreground">Usuários</span> <strong>{data?.users ?? 0}</strong></p>
              <p className="flex justify-between"><span className="text-muted-foreground">Funcionários (ativos ou não)</span> <strong>{data?.employees ?? 0}</strong></p>
            </div>
          )}
        </PanelCard>
      </div>
    </div>
  );
}
